export const LogoutBigIcon = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.575 53.5357H22.8729C33.0479 53.5357 37.9521 49.5253 38.8 40.5419C38.8917 39.6023 38.2042 38.7544 37.2417 38.6628C36.325 38.5711 35.4542 39.2815 35.3625 40.2211C34.6979 47.4169 31.3062 50.0982 22.85 50.0982H22.5521C13.225 50.0982 9.92499 46.7982 9.92499 37.4711V22.5294C9.92499 13.2023 13.225 9.90234 22.5521 9.90234H22.85C31.3521 9.90234 34.7437 12.6294 35.3625 19.9628C35.4771 20.9023 36.2792 21.6128 37.2417 21.5211C38.2042 21.4523 38.8917 20.6044 38.8229 19.6648C38.0437 10.544 33.1167 6.46484 22.8729 6.46484H22.575C11.3229 6.46484 6.51041 11.2773 6.51041 22.5294V37.4711C6.51041 48.7232 11.3229 53.5357 22.575 53.5357Z"
        fill="#222530"
      />
      <path
        d="M23.1249 31.7188H49.2041C50.1437 31.7188 50.9229 30.9396 50.9229 30C50.9229 29.0604 50.1437 28.2812 49.2041 28.2812H23.1249C22.1854 28.2812 21.4062 29.0604 21.4062 30C21.4062 30.9396 22.1854 31.7188 23.1249 31.7188Z"
        fill="#222530"
      />
      <path
        d="M44.0938 39.3963C44.5292 39.3963 44.9646 39.2359 45.3084 38.8921L52.9854 31.215C53.65 30.5505 53.65 29.4505 52.9854 28.7859L45.3084 21.1088C44.6438 20.4442 43.5438 20.4442 42.8792 21.1088C42.2146 21.7734 42.2146 22.8734 42.8792 23.538L49.3417 30.0005L42.8792 36.463C42.2146 37.1275 42.2146 38.2275 42.8792 38.8921C43.2 39.2359 43.6584 39.3963 44.0938 39.3963Z"
        fill="#222530"
      />
    </svg>
  );
};
